import type { StyledCreditCardInputProps } from '../StyledStripeInput';
import { StyledStripeInput } from '../StyledStripeInput';

export type CreditCardExpiryProps = Omit<
  StyledCreditCardInputProps<'cardExpiry'>,
  'type'
>;

/**
 * Render a Credit Card Expiry input. Must be child of {@link StripeProvider} and
 * {@link StripeElementsProvider}.
 */
export function CreditCardExpiry(props: CreditCardExpiryProps) {
  return <StyledStripeInput type="cardExpiry" {...props} />;
}
